// Diálogo modal: atenúa el fondo para centrar la atención en una decisión
import { useEffect, type ReactNode } from 'react';
import { motion, AnimatePresence } from 'framer-motion';

const SHEET_SPRING = { type: 'spring', bounce: 0, duration: 0.35 } as const;

export default function Modal({ open, onClose, children, labelledBy, dismissable = true }: {
  open: boolean;
  onClose: () => void;
  children: ReactNode;
  labelledBy?: string;
  // false: solo se cierra con los botones del diálogo
  dismissable?: boolean;
}) {
  useEffect(() => {
    if (!open || !dismissable) return;
    const onKey = (e: KeyboardEvent) => { if (e.key === 'Escape') onClose(); };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, dismissable, onClose]);

  return (
    <AnimatePresence>
      {open && (
        <motion.div
          className="fixed inset-0 z-[60] grid place-items-center p-4 bg-black/40"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          transition={{ duration: 0.2 }}
          onClick={dismissable ? onClose : undefined}
        >
          <motion.div
            role="dialog"
            aria-modal="true"
            aria-labelledby={labelledBy}
            className="w-full max-w-sm rounded-3xl bg-surface shadow-float p-6"
            initial={{ opacity: 0, scale: 0.94, filter: 'blur(6px)' }}
            animate={{ opacity: 1, scale: 1, filter: 'blur(0px)' }}
            exit={{ opacity: 0, scale: 0.97, filter: 'blur(4px)' }}
            transition={SHEET_SPRING}
            onClick={(e) => e.stopPropagation()}
          >
            {children}
          </motion.div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}
